<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} loại lỗi</h1>

          <div style="float: right">
            <button type="button" @click="$router.push('/error-type')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="" vid="sourceInform" name="Mã lỗi" v-if="!!dataRequest.id">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Mã lỗi </label>
                  <div class="col-sm-9">
                    <input type="text" disabled v-model="dataRequest.code" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="name" name="Tên lỗi">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Tên lỗi<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="dataRequest.description"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="idAbbreviation" name="Loại thiết bị">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Loại thiết bị<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <input
                      v-if="!!dataRequest.id"
                      type="text"
                      disabled
                      v-model="dataRequest.name"
                    />
                    <Select2 v-else v-model="dataRequest.idAbbreviation" :options="dataDevice" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="typeDevice" name="Mức độ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mức độ<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.typeDevice" :options="Config.errorTypeDevice" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Mô tả">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Ghi chú</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  export default {
    name: 'error-type-request',
    data() {
      return {
        Config,
        dataRequest: {},
        dataDevice: [],
        showLoading: false,
      }
    },
    created() {
      if (this.$route.params.id) {
        this.fetchData()
      } else {
        DeviceService.typeDeviceConfig()
          .then(
            s => s.data?.map(s => ({ id: s.id, text: s.name, abbreviation: s.abbreviation })) ?? []
          )
          .then(
            s =>
              (this.dataDevice = [
                { id: 'OTHER', text: 'Thiết bị khác', abbreviation: 'OTHER' },
                ...s,
              ])
          )
      }
    },
    methods: {
      async submitRequest() {
        try {
          this.showLoading = true
          const params = this.preareData()
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            params.code = this.dataRequest.code
            const response = await DeviceService.updateErrorType(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật lỗi thành công').then(() =>
                this.$router.push('/error-type')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await DeviceService.createErrorType(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới lỗi thành công').then(() =>
                this.$router.push('/error-type')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      preareData() {
        let abbreviation = ''
        let name = ''
        if (this.dataRequest.id) {
          abbreviation = this.dataRequest.abbreviation
          name = this.dataRequest.name
        } else {
          const dataFindDevice = this.dataDevice.find(
            item => item.id === this.dataRequest.idAbbreviation
          )
          if (dataFindDevice) {
            abbreviation = dataFindDevice.abbreviation
            name = dataFindDevice.text
          }
        }
        const data = {
          description: this.dataRequest.description,
          abbreviation: abbreviation,
          name: name,
          note: this.dataRequest.note,
          typeDevice: this.dataRequest.typeDevice,
        }
        return data
      },
      async fetchData() {
        const id = this.$route.params.id
        if (id) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.getDetailErrorType(id)
            this.dataRequest = responsive.data
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
